import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-12 gap-3 md:gap-4" }
const _hoisted_2 = { class: "col-span-12 xxl:col-span-12 grid grid-cols-12 gap-6" }
const _hoisted_3 = { class: "col-span-12 mt-4" }
const _hoisted_4 = { class: "intro-y flex flex-row items-center h-auto sm:h-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-medium truncate" }, "Data Leaderboard", -1)
const _hoisted_6 = { class: "ml-auto mt-2 sm:mt-0 flex flex-row items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden md:block" }, "Reload Data", -1)
const _hoisted_8 = { class: "intro-y col-span-12" }
const _hoisted_9 = { class: "intro-y col-span-12 box pt-3 px-3 pb-5" }
const _hoisted_10 = { class: "grid grid-cols-8 gap-2 mb-3" }
const _hoisted_11 = { class: "flex flex-col col-span-8 md:col-span-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "text-base mr-auto mb-1 md:mb-0" }, " Filter : ", -1)
const _hoisted_13 = { class: "w-full flex flex-row" }
const _hoisted_14 = { class: "flex flex-col col-span-8 md:col-span-2 items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "text-base mr-auto mb-1 md:mb-0" }, " Tipe : ", -1)
const _hoisted_16 = { class: "w-full flex flex-row" }
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "w-full col-span-8 md:col-span-4" }
const _hoisted_19 = { class: "w-full md:w-56 relative text-gray-700 dark:text-gray-300 md:ml-auto" }
const _hoisted_20 = { class: "overflow-x-auto scrollbar-nav-soal" }
const _hoisted_21 = { class: "table" }
const _hoisted_22 = { class: "border-b dark:border-dark-5 whitespace-nowrap w-20" }
const _hoisted_23 = { class: "w-12 h-12 rounded-full overflow-hidden shadow-lg image-fit zoom-in" }
const _hoisted_24 = ["src", "title"]
const _hoisted_25 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_26 = { class: "border-b dark:border-dark-5 whitespace-nowrap" }
const _hoisted_27 = {
  key: 0,
  class: "w-full p-5 flex items-center justify-center"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("p", { class: "text-base font-bold" }, "Tidak Ada Data Leaderboard.", -1)
const _hoisted_29 = [
  _hoisted_28
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RefreshCcwIcon = _resolveComponent("RefreshCcwIcon")!
  const _component_Litepicker = _resolveComponent("Litepicker")!
  const _component_TailSelect = _resolveComponent("TailSelect")!
  const _component_SearchIcon = _resolveComponent("SearchIcon")!
  const _component_LoadingDiv = _resolveComponent("LoadingDiv")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.getData())),
              class: "button bg-theme-1 hover:bg-primary text-white flex"
            }, [
              _createVNode(_component_RefreshCcwIcon, { class: "w-4 h-4 mr-0 md:mr-2" }),
              _hoisted_7
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_Litepicker, {
                modelValue: _ctx.dataLB.dateRange,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dataLB.dateRange) = $event)),
                options: {
                  autoApply: false,
                  singleMode: false,
                  numberOfColumns: 2,
                  numberOfMonths: 2,
                  showWeekNumbers: true,
                  dropdowns: {
                    minYear: 1990,
                    maxYear: null,
                    months: true,
                    years: true,
                  },
                },
                class: "input w-56 border block"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createVNode(_component_TailSelect, {
                modelValue: _ctx.dataLB.tipe,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.dataLB.tipe) = $event)),
                options: {
                  classNames: 'w-full',
                }
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listTipe, (k, idx) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: idx,
                      value: k.value
                    }, _toDisplayString(k.title), 9, _hoisted_17))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.getData())),
                class: "button bg-theme-1 hover:bg-primary text-white w-24 ml-2"
              }, " View ")
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "input w-full box pr-10 border border-gray-400 dark:bg-dark-4",
                placeholder: "Search...",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dataLB.search) = $event)),
                onKeyup: _cache[5] || (_cache[5] = _withKeys(($event: any) => (_ctx.getData()), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.dataLB.search]
              ]),
              _createVNode(_component_SearchIcon, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.getData())),
                class: "w-4 h-4 absolute my-auto inset-y-0 mr-3 right-0 cursor-pointer"
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("table", _hoisted_21, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.titleTable, (k, idx) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: idx,
                    class: "border-b-2 dark:border-dark-5 whitespace-nowrap"
                  }, _toDisplayString(k), 1))
                }), 128))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dataLB.data, (u, idx) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: idx,
                  class: _normalizeClass([idx % 2 === 0 ? 'bg-gray-200 dark:bg-dark-1' : ''])
                }, [
                  _createElementVNode("td", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("img", {
                        class: "w-full",
                        src: u.photo,
                        alt: "photo-user",
                        title: 'Photo ' + u.name,
                        "data-action": "zoom"
                      }, null, 8, _hoisted_24)
                    ])
                  ]),
                  _createElementVNode("td", _hoisted_25, _toDisplayString(u.name), 1),
                  _createElementVNode("td", _hoisted_26, _toDisplayString(u.jumlah), 1)
                ], 2))
              }), 128))
            ])
          ]),
          (_ctx.dataLB.data.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, _hoisted_29))
            : _createCommentVNode("", true),
          _createVNode(_component_LoadingDiv, { id: "loadingDataLB" })
        ])
      ])
    ])
  ]))
}